/**
 * Home Page Component
 *
 * アプリケーションのトップページ。
 */

'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useProcessing } from '@/shared/hooks/useProcessing';
import { ScreenUrl } from '@/shared/constant/common';

export default function HomePage() {
  const router = useRouter();
  /** ローディング表示制御 */
  const processing = useProcessing();

  useEffect(() => {
    processing.show();
    router.replace(ScreenUrl.Dashboards);
    processing.hide();
  }, [router]);

  // return <main className="flex flex-col min-h-screen items-center justify-center"></main>;
  return <></>;
}
